// extracted by mini-css-extract-plugin
export default {"controlGroup":"WSControlGroup-module_controlGroup-ovUS3"};